import React from 'react';

export default function LotPopulationInfo({ lot }) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Population Data</h3>
      </div>
      <dl className="divide-y divide-gray-200">
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Mintage</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {lot.mintage ? new Intl.NumberFormat('en-US').format(Number(lot.mintage)) : '—'}
          </dd>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Population</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">{lot.population || '—'}</dd>
        </div>
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Pop Higher</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">{lot.pop_higher || '—'}</dd>
        </div>
      </dl>
    </div>
  );
}
